'use strict';

import 'document-register-element';
import resizeStore from '../resize/resize.store';
import {http} from '../utils';
import dispatcher from '../dispatcher';


class AssortmentForm extends HTMLFormElement{
  constructor(self) {
    self = super(self);
    self.init.call(self);
  }
  init() {
  }
  connectedCallback() {
    const name = this.dataset.name;
    const action = this.action;

    this.switcher = this.querySelector('.assortmentSwitcher');
    this.switchItems = this.querySelectorAll('.assortmentSwitcherItem');

    this.switcher.addEventListener('change', (e) => {
      e.preventDefault();
      e.stopPropagation();

      if (this.switcher.checked) {
        this.switchItems[0].classList.remove('active');
        this.switchItems[1].classList.add('active');
      } else {
        this.switchItems[0].classList.add('active');
        this.switchItems[1].classList.remove('active');
      }
    })

    this.addEventListener('submit', e => e.preventDefault());
    this.addEventListener('change', () => {
      const data = new FormData(this);
      if (!data.has(name)) return;

      const search = new URLSearchParams(data);
      const queryString = search.toString();

      dispatcher.dispatch({
        type: 'route-change',
        route: {
          href: action + queryString
        }
      });
      // this.submit();
    });
  }
  disconnectedCallback() {
  }

}

window.customElements.define('assortment-form', AssortmentForm, {extends: 'form'});